import React, { Fragment, useState, useEffect, useRef } from 'react';

import { Button } from "react-bootstrap";
import { connect } from 'react-redux';
// import { submitForm } from './search/redux/actions/actions';
import { Translation, useTranslation } from 'react-i18next';
import Select2Wrapper from '../Select2Wrapper';
import Cookies from 'js-cookie';
import $ from 'jquery';

import OmantelVisaHeader from './OmantelVisaHeader';

import '@fontsource/ibm-plex-sans/400.css';  // Regular weight
import '@fontsource/ibm-plex-sans/500.css';  // Medium weight
import '@fontsource/ibm-plex-sans/600.css';  // Semi-bold weight

import "./OmantelVisaStyle.css";
const { config } = require('../api/api');


function OmantelVisaForm() {

  const [searchData, setSearchData] = useState(null);
  const [options, setCountries] = useState([]);
  const [countryList,setCountryList]=useState([]);
  const [selectedCountry,setSelectedCountry]=useState(null);
  const base_url = config.baseURL;
  const [vendorKey, setVendorkey] = useState(null);
  const [formData,setFormData]=useState(null);
  const [visaDetails,setVisaDetails]=useState(null);
  const [phoneCode,setPhoneCode]=useState("");
  const selectOpt1=useRef(null);
  const [visaInfo,setVisaInfo]=useState(null);
  const [omrAmount, setOmrAmount] = useState('');
  const [searchResult, setSearchResult] = useState(false);
  const [loading,setLoading]=useState(false);
  const [lnstr,setlnstr]=useState("en");
  const [userData,setUserdata]=useState(null);
  const [userToken,setUserToken]=useState(null);
  const [isChecked,setIschecked]=useState(false);
  const [usrtok,setUsrtok]=useState(null);
  const [storedUser,setStoredUser]=useState(null);
  const phoneRef=useRef(null);
  const [phoneErr,setPhoneErr]=useState("");

  // Translation

    const { t,i18n } = useTranslation();

    useEffect(()=>{
      debugger
      const getVisaDetails=sessionStorage.getItem("visaInfo");
      // const getFormDetails=sessionStorage.getItem("visaFormDetails");
      // if(getFormDetails){
      //   const parseFormData=JSON.parse(getFormDetails);

      //   setFormData(parseFormData);
      //   setSelectedCountry(parseFormData.country);
      //   setPhoneCode(parseFormData.phoneCode);
        
      // }
      if(getVisaDetails){
        const parseVisaInfo=JSON.parse(getVisaDetails);
      
      setVisaInfo(parseVisaInfo);

      if(parseVisaInfo?.locale){
      i18n.changeLanguage(parseVisaInfo?.locale)
      setlnstr(parseVisaInfo?.locale);
      }
      }
    },[])


       // Function to update HTML dir attribute based on language
      const updateHtmlDirAttribute = () => {
        document.documentElement.dir = i18n.dir(); // Set document direction
      };
    
      // Update HTML dir attribute when component mounts and language changes
      useEffect(() => {
        updateHtmlDirAttribute();
      }, [i18n.language]);

 useEffect(() => {
      
          const postvData = { organization_name: "Omantel" };
          debugger
      
          if (vendorKey === '' || vendorKey === null || vendorKey === undefined) {
      
            debugger
            fetch(base_url + '/create_organization', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(postvData),
            })
              .then(response => response.json())
              .then(data => {
                setVendorkey(data.result[0].vendor_key);
                
              })
              .catch(error => {
                console.error('Error posting data:', error);
              });
      
      
          }
        }, [vendorKey]);

        useEffect(() => {
            var selectedValue;
            $(selectOpt1.current).select2();
  
            // document.querySelectorAll(".select2-selection--single").forEach((element) => {
            //   element.style.setProperty("border-radius", "5px", "important");
            //   element.style.setProperty("border", "1px solid #ced4da", "important");
            // });
             $(selectOpt1.current)
                      .next(".select2-container")
                      .find(".select2-selection--single")
                      .each(function() {
                          $(this).addClass("omantel");  // Adds the "omantal" class alongside the existing classes
                      });
                      $(selectOpt1.current)
                      .next(".select2-container")
                      .find(".select2-dropdown.select2-dropdown--below")
                      .each(function() {
                          $(this).addClass("select_drawer");  // Adds the "omantal" class alongside the existing classes
                      });
            // $(selectOpt1.current).next(".select2-container").find(".select2-selection--single").each(function () {
            //   $(this).css("border-radius", "5px");
            //   $(this).css("border", "1px solid #ced4da");
            //   this.style.setProperty("border-radius", "5px", "important");
            //   this.style.setProperty("border", "1px solid #ced4da", "important");
            // });
            $(selectOpt1.current).on('select2:select', (e) => {
              debugger
              // selectedValue = e.params.data.text;
              const country = e.params.data.id;
        
              if(country!==null && country!==undefined && country!=="Select" && country!==""){
                $(selectOpt1.current)
                .next(".select2-container")
                .find(".select2-selection--single.omantel")
                .each(function() {
                    $(this).removeClass("error");  // Adds the "omantal" class alongside the existing classes
                });
              }
              
             
              setSelectedCountry(country);
              checkCountryStatus(country);
              
             
              // setAirPortId(selectairport_id);
            });
            
            // Clean up Select2 instance on unmount
            return () => {
              $(selectOpt1.current).select2('destroy');
            };
          }, [vendorKey]);
          useEffect(() => {
            if (selectedCountry && selectOpt1.current) {
              $(selectOpt1.current).val(selectedCountry).trigger('change.select2');
            }
          }, [selectedCountry]);

          useEffect(()=>{
          debugger
            if(selectedCountry!==null && selectedCountry!==undefined && selectedCountry!=="" && selectedCountry!=="Select"){
                debugger
                const filter=countryList.find((obj)=> obj.country===selectedCountry);
                if(filter){
                setPhoneCode(filter?.country_code);
                }
                $(selectOpt1.current)
                .next(".select2-container")
                .find(".select2-selection--single.omantel")
                .each(function() {
                    $(this).addClass("success");  // Adds the "omantal" class alongside the existing classes
                });
              }

          },[selectedCountry]);


          const checkCountryStatus=(country)=>{
            if(country!==null&&country!==undefined&&country!==""&&country!=="Select"){
                debugger

                $(selectOpt1.current)
                .next(".select2-container")
                .find(".select2-selection--single.omantel")
                .each(function() {
                    $(this).addClass("success");  // Adds the "omantal" class alongside the existing classes
                });
              }
          }

           useEffect(async () => {
              debugger
              const storedResultString = sessionStorage.getItem('VisaSearchResult');
              const userData= sessionStorage.getItem("userDataForVisa");
              if (storedResultString !== "undefined") {
                const storedResult = JSON.parse(storedResultString);
                debugger;
                if(storedResult != null && storedResult != undefined && storedResult.fee != null && storedResult.fee != undefined){
                  await getOMRAmount(storedResult.fee,storedResult.currency);
                }
               
                setSearchResult(storedResult);
              }
              if(userData !== "undefined"){
                       const parseUserData=JSON.parse(userData);
                       setUserdata(parseUserData);
                       setUserToken(parseUserData?.access_token);
              }
            }, []);

            const getOMRAmount = (amount, currency) => {
              debugger
                  fetch(base_url+'/amount_convertion', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                      "amount":amount,
                      "currency": currency
                  }),
                  })
                    .then(response => response.json())
                    .then(data => {
                      debugger;
                      if(data['message'] == 'success'){
                        var result = data['result'];
                        var split_data = result.split('.');
                        var convertion_amount = '';
                        if(split_data[1].length >= 3){
                          convertion_amount = split_data[0] +'.'+ result.split('.')[1].substring(0, 3);
                        }else{
                          convertion_amount = result;
                        }
                        setOmrAmount(convertion_amount);
                      }
                     
                      // setVendorKey(data.result[0].vendor_key);
                    })
                    .catch(error => {
                      console.error('Error posting data:', error);
                    });
                 
                };

            useEffect(() => {
                
                    if(vendorKey!=='' && vendorKey!==null && options.length===0)
                    {
                
                      var vkData = {vendor_key: vendorKey};
                
                      fetch(base_url+'/country', {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(vkData),
                      })
                          .then(response => response.json())
                          .then(data => {
                            // debugger
                            setCountries(data.result);
                            setCountryList(data.result);
                          })
                          .catch(error => {
                            console.error('Error fetching countries:', error);
                          });

                   
                      
                      
                
                    }
                
                  }, [vendorKey]);

                  useEffect(()=>{
                       //session 
                       const getUserDetails=()=>{
                        const storedUserString = sessionStorage.getItem('userDataForVisa');
                        if (storedUserString !== undefined) {
                          const user_data = JSON.parse(storedUserString);
                        
                         
                          const vkData = { vendor_key: vendorKey };
                          if (user_data.agency_name === null || user_data.agency_name === undefined || user_data.agency_name === '') {
                            // setIsReadOnly(true);
                            setUsrtok(user_data.access_token);
                            const token = user_data.access_token;
                            fetch(base_url + '/each_omantel_traveller_details', {
                    
                              method: 'POST',
                              headers: {
                                'Authorization': `Bearer ${token}`,
                                'Content-Type': 'application/json'
                              },
                              body: JSON.stringify(vkData),
                            })
                              .then(response => response.json())
                              .then(data => {
                                debugger
                                setStoredUser(data.result[0]);
                                const user=data.result[0];
                                const getUserData={
                                  firstName:user?.first_name,
                                  lastName:user?.last_name,
                                  email:user?.email,
                                  building:user?.building,
                                  floor:user?.floor,
                                  apartment:user?.apartment,
                                  street: user?.street,
                                  city:user?.city,
                                  state:user?.state,
                                  phoneNumber:user?.phone
          
                                }
                               
                                setFormData(getUserData);
                                setSelectedCountry(user?.country);
                                // check country valid or not 
                                checkCountryStatus(user?.country);
                                setPhoneCode(user?.country_code);
                              })
                              .catch(error => {
                                console.error('Error fetching countries:', error);
                              });
                    
                          
                          }
                    
                         
                        } else {
                          alert('Login Session Expired');
                          window.location.href = '/';
                        }
                      }
                      if(vendorKey && options?.length>0 ){
                             getUserDetails();
                      }

                  },[vendorKey,options])
                  
                  const handleChange=(e)=>{
                    const {name,value}=e.target;
                    if(name==="firstName" || name==="lastName"){
                        const namevalidate=value.trimStart().replace(/[^a-zA-Z\s]/g, "").replace(/\s+/g," ");
                    setFormData((data)=>({...data,[name]:namevalidate}));
                    }
                    else if(name==="phoneNumber"){
                        const phonevalidate = value.replace(/\D/g, "").trim();
                        setFormData((data)=>({...data,[name]:phonevalidate}));

                    }
                    else{
                        setFormData((data)=>({...data,[name]:value}));
                    }

                  }
                 

                 
                  useEffect(()=>{
                        if(formData?.phoneNumber!==""&& formData?.phoneNumber!==null && formData?.phoneNumber!==undefined){
                                      setPhoneErr("");
                        }
                  },[formData])

                 const  handleSubmit=async(e)=>{
                    e.preventDefault();

debugger
const phone = formData?.phoneNumber;
if((selectedCountry===null || selectedCountry===undefined || selectedCountry==="Select"||selectedCountry==="")||(phone === null || phone === undefined || phone === "")){
                    if(selectedCountry===null || selectedCountry===undefined || selectedCountry==="Select"||selectedCountry===""){
                    $(selectOpt1.current)
                .next(".select2-container")
                .find(".select2-selection--single.omantel")
                .each(function() {
                    $(this).removeClass("success");  // Adds the "omantal" class alongside the existing classes
                });
                           $(selectOpt1.current)
                      .next(".select2-container")
                      .find(".select2-selection--single.omantel")
                      .each(function() {
                          $(this).addClass("error");  // Adds the "omantal" class alongside the existing classes
                      });
                      selectOpt1.current.focus();
                    }
debugger
                    if (phone === null || phone === undefined || phone === "") {

                      setPhoneErr("phoneNoEmpty");
                      phoneRef.current.focus();
                      
                    }
                    return;
                  }
                  else{
                    debugger
                    setLoading(true)
                    const getUserData=sessionStorage.getItem("userDataForVisa");
                    
                    const parseData=getUserData?JSON.parse(getUserData):"";

                    // var form_data={...formData,country_code:phoneCode,country:selectedCountry,}

                   if(parseData?.id){ 
                  var req_data={
                    first_name:formData?.firstName,
                    last_name:formData?.lastName,
                    phone:formData?.phoneNumber,
                    building:formData?.building,
                    floor:formData?.floor,
                    apartment:formData?.apartment,
                    street:formData?.street,
                    city:formData?.city,
                    state:formData?.state,
                    country:selectedCountry,
                    country_code:phoneCode,
                    id:parseData?.id
                  }
                  
                  const merge_data={...formData,country:selectedCountry,phoneCode:phoneCode}
                  sessionStorage.setItem("visaFormDetails",JSON.stringify(merge_data));
                  try{
                     const response = await fetch(`${base_url}/update_traveller_omantel`,{
                                method:"POST",
                                headers:{
                                  "Authorization":`Bearer ${vendorKey}`,
                                  "Content-Type":"application/json",
                                },
                                body:JSON.stringify(req_data)
                              });
                              if(!response.ok){
                                console.log("update traveller api ERR : "+response.status+response.statusText);
                              }
                              else{
                              const data= await response.json();
                              if(data.message==="success"){
                              //  alert("user information updated");
                              }
                              }
                  }
                  catch(err){
                    console.log("ERR : "+err)
                  }
                  debugger
                  
       
                  var order_data = {
                    "vendor_key": vendorKey,
                    "reference_no": generateRandomValue(),
                    "description": "Visa Order",
                    "program_id": searchResult.id,
                    "quantity": 1,
                    "first_name": visaInfo?.first_name,
                    "last_name": visaInfo?.last_name,
                    "email": visaInfo?.email,
                    "fee": searchResult?.fee,
                    "arrival": searchData?.passportCountry,
                    "destination": searchData?.destinationCountry,
                    "commission": searchResult?.commision,
                    "commission_type": searchResult?.commision_type,
                    "travel_date": searchData?.travelDate,
                    "apartment": formData?.apartment ||"",
                    "building": formData?.building || "",
                    "floor": formData?.floor ||"",
                    "phone_no": formData.phoneNumber,
                    "street": formData?.street || "",
                    "city": formData?.city ||"",
                    "state": formData?.state ||"",
                    "country": selectedCountry
                  }
                  
                  await fetch(`${base_url}/iframe_order_visa_omantel`, {
                    method: 'POST',
                    headers: {
                      'Authorization': `Bearer ${userToken}`,
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(order_data),
                  })
                    .then(response => response.json())
                    .then(data => {
                      // sessionStorage.setItem("viplink", JSON.stringify(data.result[0].payment_link));
                      setLoading(false);
                      if (data.message === 'success') {
                        sessionStorage.setItem("order_data", JSON.stringify(order_data));
                        sessionStorage.setItem("deeplink", JSON.stringify(data));
                       
                        window.location.href = `/omantel-application`;
                      }
                    })
                    .catch(error => {
                      console.error('Error posting data:', error);
                    });
            
                 }
                }
                }
                 
                  useEffect(() => {
                    const storedSearchString = sessionStorage.getItem('visaInfo');
                    if (storedSearchString !== 'undefined') {
                      const storedSearch = JSON.parse(storedSearchString);
                      setSearchData(storedSearch);
                    }
                  }, []);
                  function generateRandomValue() {
                    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                    let randomValue = '';
                    for (let i = 0; i < 10; i++) {
                      randomValue += chars.charAt(Math.floor(Math.random() * chars.length));
                    }
                    return randomValue;
                  }

             const handleCheckBox=(e)=>{
                if(e.target.checked){
                  setIschecked(true);
                  // return;
                }
                else{
              setIschecked(false);
                }
             }   
          const disable_style={
            opacity: "0.5",
    pointerEvents: "none"
          }

           const handlePreviousBtn=()=>{
            window.location.href="/omantel-visainfo"
           }

           
          
        
      
    return (
      <>
      <OmantelVisaHeader />
        <div style={{backgroundColor:"#fcfcfc", fontFamily: 'IBM Plex Sans' }}>
            <div className='container' >
                <h1 className='visa_page_heading' >
                   {lnstr==="en" ?"Visa Application Form":"نموذج طلب التأشيرة"}
                </h1>
                <div style={{ paddingTop: "50px" }}>
                    <form onSubmit={handleSubmit} >
                        <div className='row' style={{backgroundColor:"#fafafa", display: "flex", alignContent: 'center', justifyContent: "center",marginBottom:"40px" }}>
                            <div className='col-md-6'>
                                {/* first name  */}
                                <div className="mb-3">
                                 <label className='form-label'>{t("First")} {t("Name")}<span style={{ color: "red" }}>&nbsp;*</span></label>
                                    <input type="text" name="firstName" 
                                    style={{border:visaInfo?.first_name!==""?"1px solid green !important":""}}
                                          
                                            className={`form-control omantel ${visaInfo?.first_name!=="" && visaInfo?.first_name!==null && visaInfo?.first_name!==undefined?'success':""}`}
                                        value={visaInfo?.first_name}
                                        disabled
                                        required />
                                </div>

                                {/* last name */}
                                <div className="mb-3">
                                  
                                        <label className='form-label' >{t("Last")} {t("Name")}<span style={{ color: "red" }}>&nbsp;*</span></label>
                                    <input type="text" name="lastName" 
                                     
                                      className={`form-control omantel ${visaInfo?.last_name!=="" && visaInfo?.last_name!==null && visaInfo?.last_name!==undefined?'success':""}`}
                                      value={visaInfo?.last_name}
                                      disabled
                                        required />
                                </div>

                                {/* email */}
                                <div className="mb-3">
                                   
                                        <label className='form-label'>{t("Email")}<span style={{ color: "red" }}>&nbsp;*</span></label>
                                    <input type="text" name="email" 
                                    className={`form-control omantel ${visaInfo?.email!=="" && visaInfo?.email!==null && visaInfo?.email!==undefined?'success':""}`}
                                        value={visaInfo?.email}

                                        disabled
                                        required />
                                </div>

                                <div className='row'>
                                    <div className='col-6'>
                                        {/* Building */}
                                        <div className="mb-3">
                                                <label className='form-label'>{t("Building")}</label>
                                            <input type="text" name="building" 
                                            className={`form-control omantel ${formData?.building!=="" && formData?.building!==null && formData?.building!==undefined?'success':""}`}
                                               onChange={handleChange} 
                                               value={formData?.building}
                                                />
                                        </div>
                                    </div>
                                    <div className='col-6'>
                                        {/* floor */}
                                        <div className="mb-3">
                                                <label className='form-label'>{t("Floor")}</label>
                                            <input type="text" name="floor" 
                                          className={`form-control omantel ${formData?.floor!=="" && formData?.floor!==null && formData?.floor!==undefined?'success':""}`}
                                                  onChange={handleChange} 
                                                  value={formData?.floor}
                                                />
                                        </div>
                                    </div>
                                </div>

                                {/* Apartment */}
                                <div className="mb-3">
                                        <label className='form-label'>{t("Apartment")}</label>         
                                    <input type="text" name="apartment" 
                                   className={`form-control omantel ${formData?.apartment!=="" && formData?.apartment!==null && formData?.apartment!==undefined?'success':""}`}
                                       onChange={handleChange} 
                                       value={formData?.apartment}
                                        />
                                </div>

                                {/* Street */}
                                <div className="mb-3">
                                        <label className='form-label'>{t("Street")}</label>
                                    <input type="text" name="street" 
                                  className={`form-control omantel ${formData?.street!=="" && formData?.street!==null && formData?.street!==undefined?'success':""}`}
                                        onChange={handleChange} 
                                        value={formData?.street}
                                         />
                                </div>

                                {/* City */}
                                <div className="mb-3">
                                        <label className='form-label'>{t("City")}</label>
                                    <input type="text" name="city"
                                     className={`form-control omantel ${formData?.city!=="" && formData?.city!==null && formData?.city!==undefined?'success':""}`}
                                       onChange={handleChange} 
                                       value={formData?.city}
                                         />
                                </div>

                                {/* State */}
                                <div className="mb-3">
                                 
                                        <label className='form-label'>{t("State")}</label>
                                    <input type="text" name="state"
                                     className={`form-control omantel ${formData?.state!=="" && formData?.state!==null && formData?.state!==undefined?'success':""}`}
                                        onChange={handleChange} 
                                        value={formData?.state}
                                         />
                                </div>
                                {/* country */}
                                <div className="mb-3">
                                        <label className='form-label'>{t("Country")}<span style={{ color: "red" }}>&nbsp;*</span></label>
                                    <div className='w-100'>
                                    <select
                    ref={selectOpt1}
                    className="form-control omantel"
                    style={{ borderRadius: '5px', height: '30px', width: '100%', maxWidth: '300px' }}
                    
                    value={options.length>1?selectedCountry:""}
                    
                  >
                    <option value={''} disabled >{t("Select")}</option>
                    {options.length>1 ? options.map((country) => (
                      <option key={country.id} value={country.country}>{t(country.country)}</option>
                    )):<></>}
                  </select>
                                </div>
                                
                                </div>
                                {/* Phone No */}
                                <div className=" mb-3  ">
                                  
                                        <label className='form-label'>{t("Phone No")}<span style={{ color: "red" }}>&nbsp;*</span></label>
                                   <div className='row'>
                                    <div className='col-3'>
                                   <input type="text" 
                                className={`form-control omantel ${phoneCode!==""&& phoneCode!==null && phoneCode!==undefined?'success':""} `}
                                      value={phoneCode}
                                    
                                       disabled
                                       required />
                                   </div>
                                   
                                    <div className='col-9'>
                                    <input
                                        type="text"
                                        ref={phoneRef}
                                        name="phoneNumber"
                                        className={`form-control omantel ${formData?.phoneNumber!=="" && formData?.phoneNumber!==null && formData?.phoneNumber!==undefined?'success':""} ${phoneErr==="phoneNoEmpty"?"error":""}`}
                                        onChange={handleChange} 
                                        value={formData?.phoneNumber}
                                        style={{ borderRadius: "5px" }}
                                       
                                    />
                                    </div>
                                    </div>
                                </div>

                                {/* Passport Country */}
                                <div className="mb-3">
                                        <label className='form-label'>{t("Passport")} {t("Country")}</label>
                                    <input type="text" name="passportCountry" 
                                        className={`form-control omantel ${visaInfo?.passportCountry!=="" && visaInfo?.passportCountry!==null && visaInfo?.passportCountry!==undefined?'success':""}`}
                                        value={visaInfo?.passportCountry}
                                        disabled
                                         />
                                </div>

                                {/* Destination Country */}
                                <div className="mb-3">
                                    
                                        <label className='form-label'>{t("Destination")} {t("Country")}</label>
                                    <input type="text" name="destinationCountry"
                                        //    onChange={}
                                        className={`form-control omantel ${visaInfo?.destinationCountry!=="" && visaInfo?.destinationCountry!==null && visaInfo?.destinationCountry!==undefined?'success':""}`}
                                        value={visaInfo?.destinationCountry}
                                        disabled
                                         />
                                </div>
                                {/* Visa Fee */}
                                <div className="mb-3">
                                        <label className='form-label'>{t("Visa")} {t("Fee")}</label>
                                    <input type="text" name="visaFee" 
                                        className={`form-control omantel ${searchResult?.fee!=="" && searchResult?.fee!==null && searchResult?.fee!==undefined?'success':""}`}
                                        value={`${searchResult?.fee} ${searchResult['currency']} (${omrAmount} OMR)`}
                                        disabled
                                         />
                                </div>

                                {/* Travel Date */}
                                <div className="mb-3">
                                        <label className='form-label'>{t("Travel")} {t("Date")}</label>
                                    <input type="text" name="visaFee" 
                                         className={`form-control omantel ${visaInfo?.travelDate!=="" && visaInfo?.travelDate!==null && visaInfo?.travelDate!==undefined?'success':""}`}
                                        value={visaInfo?.travelDate}
                                        disabled
                                         />
                                </div>
                                <br />
                                <p style={{fontSize:"16px"}}>{lnstr==="en" ?"We use this to create your E-Visa and send you updates about your application":"نحن نستخدم هذه المعلومات لإنشاء تأشيرتك الإلكترونية وإرسال تحديثات إليك حول طلبك"}</p>
                                 
                                 <input type="checkbox" style={{display:"inline-block",padding:"10px"}} checked={isChecked===true} onChange={(e)=>handleCheckBox(e)} /><label style={{display:"inline",fontSize:"16px"}}>&nbsp;{lnstr==="en" ?"I want to receive E-Visa updates, product launches and personalized offers. I can opt out anytime.":"أرغب في تلقي تحديثات التأشيرة الإلكترونية، وإطلاق المنتجات، والعروض المُخصصة. يُمكنني إلغاء الاشتراك في أي وقت."} </label>
                                
                                 <div className="find_visa_btn"  style={{marginTop:"50px",display:"flex",justifyContent:"center"}}>
                           <button type="submit" style={isChecked ? {}:disable_style} disabled={loading}>
                           {!loading?
                           <span>
                           {lnstr==="en" ?"Submit":"يُقدِّم"} </span>:<div class="d-flex  justify-content-center"><div class="omantel-loader"></div></div>}
                            </button>
             </div>
                        
                           
                            </div>
                        </div>
                      
                    </form>

                </div>
                {/* back button */}
                <div className='mt-4 d-flex justify-content-center mb-4'>
                                      <button style={{ color: "#FF7900", backgroundColor: '#FFF2E6',padding:"2px 10px" }} className='px-4' onClick={handlePreviousBtn} >
                                      <i class="fas fa-arrow-left"></i>
                                      </button>
                                </div>
            </div>
        </div>
      
        </>
    )
}
export default OmantelVisaForm;